import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/** Опций пагинации для грида. */
let DxGridPaginationOptions = class DxGridPaginationOptions {
    /** Опций пагинации для грида. */
    constructor() {
        /**
         * Активация автоподгонки размера страницы.
         * Грид автоматически подгоняет размер страницы, так чтоб полностью заполнить по высоте область,
         * выделенную под таблицу.
         */
        this._useAutoPageSize = false;
        /** Флаг позволяет отключить встроенную панель с пагинацией и использовать внешнюю. */
        this._suppressDefaultPaginationPanel = false;
    }
    get useAutoPageSize() {
        return this._useAutoPageSize;
    }
    set useAutoPageSize(value) {
        this._useAutoPageSize = value;
    }
    get pageSize() {
        return this._pageSize;
    }
    set pageSize(value) {
        this._pageSize = value;
    }
    get suppressDefaultPaginationPanel() {
        return this._suppressDefaultPaginationPanel;
    }
    set suppressDefaultPaginationPanel(value) {
        this._suppressDefaultPaginationPanel = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "useAutoPageSize", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridPaginationOptions.prototype, "_useAutoPageSize", void 0);
tslib_1.__decorate([
    jsonMember({ name: "pageSize", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxGridPaginationOptions.prototype, "_pageSize", void 0);
tslib_1.__decorate([
    jsonMember({ name: "suppressDefaultPaginationPanel", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridPaginationOptions.prototype, "_suppressDefaultPaginationPanel", void 0);
DxGridPaginationOptions = tslib_1.__decorate([
    jsonObject
], DxGridPaginationOptions);
export { DxGridPaginationOptions };
